module.exports = __webpack_public_path__ + "static/media/Keuringsfirma_logo_pos_RGB.a89eb40b.png";